/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type CreateWidgetRequestBody = {
  /**
   * Catalog dataset the widget asks
   */
  dataset: string;
  /**
   * What the widget is for, at most 2000 characters
   */
  description?: string | undefined;
  /**
   * Display name, at most 200 characters
   */
  name: string;
  /**
   * The question. Validated against the catalog on save.
   */
  query: { [k: string]: any };
  /**
   * How the question is drawn. Checked against the question on save.
   */
  visualization: { [k: string]: any };
};

/** @internal */
export type CreateWidgetRequestBody$Outbound = {
  dataset: string;
  description?: string | undefined;
  name: string;
  query: { [k: string]: any };
  visualization: { [k: string]: any };
};

/** @internal */
export const CreateWidgetRequestBody$outboundSchema: z.ZodMiniType<
  CreateWidgetRequestBody$Outbound,
  CreateWidgetRequestBody
> = z.object({
  dataset: z.string(),
  description: z.optional(z.string()),
  name: z.string(),
  query: z.record(z.string(), z.any()),
  visualization: z.record(z.string(), z.any()),
});

export function createWidgetRequestBodyToJSON(
  createWidgetRequestBody: CreateWidgetRequestBody,
): string {
  return JSON.stringify(
    CreateWidgetRequestBody$outboundSchema.parse(createWidgetRequestBody),
  );
}
